import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" About company - ")
const _hoisted_6 = { class: "d-grid gap-2 d-md-flex justify-content-md-end" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Save changes ")
const _hoisted_10 = { class: "card-body p-9" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Type of work:", -1)
const _hoisted_14 = { class: "col-12 mt-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "We value workers who:", -1)
const _hoisted_16 = { class: "col-12 mt-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Safety requirements:", -1)
const _hoisted_18 = { class: "col-12 mt-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Preffered dresscode:", -1)
const _hoisted_20 = { class: "col-12 mt-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Water policy:", -1)
const _hoisted_22 = { class: "col-12 mt-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Food policy:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_router_link, {
                to: `/client/${_ctx.company.id}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.company.name), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveData && _ctx.saveData(...args))),
              class: "btn btn-sm btn-success align-self-center",
              disabled: _ctx.isUpdatingCompany
            }, [
              (_ctx.isUpdatingCompany)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                : _createCommentVNode("", true),
              _hoisted_9
            ], 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control form-control-solid",
                placeholder: "What kind of work you usually do ?",
                rows: "2",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputData.typeOfWork) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inputData.typeOfWork]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control form-control-solid",
                placeholder: "What are the expectations from workers ?",
                rows: "2",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputData.workerType) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inputData.workerType]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control form-control-solid",
                placeholder: "Enter your safety requirements.",
                rows: "2",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputData.safetyReqs) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inputData.safetyReqs]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control form-control-solid",
                placeholder: "Any preferences on dresscodes ?",
                rows: "2",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputData.prefDresscode) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inputData.prefDresscode]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control form-control-solid",
                placeholder: "Enter your company's water policy.",
                rows: "2",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputData.waterPolicy) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inputData.waterPolicy]
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control form-control-solid",
                placeholder: "Enter your company's food policy.",
                rows: "2",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputData.foodPolicy) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inputData.foodPolicy]
              ])
            ])
          ])
        ])
      ]))
}